import BudgetTable from '../screens/budget-table'

onDomLoad(function () {
  const element = document.querySelector('[data-behaviour="budget-table"]')
  if (element) {
    window.BudgetTable = new BudgetTable(element)
  }
})
